(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bff-signature-selection"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = () => {
    const key = new URLSearchParams(window.location.search).get('bff_combo');
    if (!['birthday','hug','well'].includes(key)) return;
    document.querySelectorAll('[data-bff-pair]').forEach(pair => {
      if (pair.dataset.bffPair !== key || pair.dataset.initialised) return;
      pair.dataset.initialised = 'true';
      const input = pair.querySelector('[data-bff-combo-choice]');
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', {bubbles:true}));
      const status = pair.querySelector('[role="status"]');
      if (status) status.hidden = false;
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise,{once:true}); else initialise();
  document.addEventListener('shopify:section:load',initialise);
  document.addEventListener('change',event => {
    if(!event.target.matches('[data-bff-combo-choice]')) return;
    const status=event.target.closest('[data-bff-pair]').querySelector('[role="status"]');
    if(status) status.hidden=!event.target.checked;
  });
  document.addEventListener('product-ajax:added',() => document.querySelectorAll('.bff-pair__status').forEach(node=>node.hidden=true));
})();
  } catch(e) { console.error(e); }
})();

})();
